import type { KnowledgeArticleTranslations } from './articles.types';

export const KNOWLEDGE_BASE_ARTICLES_AR: KnowledgeArticleTranslations = {
  supply: {
    title: 'أهداف التوريد',
    content:
      'تتيح صفحة التوريد تحديد كمية المواد التي تتوقعها منظمة إعادة التدوير استلامها. تُستخدم الأهداف لمتابعة التنفيذ في لوحة القياس.\n\nاختر من الخيارات أدناه لمعرفة الخطوات خطوة بخطوة.',
  },
  'supply-overview': {
    title: 'نظرة عامة على التوريد',
    content:
      '1. افتح «التوريد» من الشريط الجانبي.\n\n2. اختر منظمة إعادة التدوير من القائمة المنسدلة أعلى الشريط الجانبي.\n\n3. استخدم مفتاح «أسبوعي / شهري» فوق جدول المواد لتحديد فترة الهدف.\n\n4. راجع وعدّل صفوف المواد في الجدول.\n\n5. انقر «حفظ» في رأس الصفحة (أعلى اليمين) وانتظر رسالة النجاح.\n\n6. افتح «لوحة القياس» من الشريط الجانبي للتحقق من انعكاس الأهداف المحفوظة.\n\nنصيحة: إذا كانت الصفحة فارغة، أضف صف مادة واحداً على الأقل مع فئة نفايات وكمية. إذا فشل الحفظ، تأكد أن كل صف له فئة وكمية أكبر من صفر.',
  },
  'supply-material-lines': {
    title: 'صفوف المواد',
    content:
      '1. في صفحة التوريد، انقر «إضافة صف» لإنشاء صف مادة جديد.\n\n2. اختر فئة النفايات من القائمة (تُستمد من مواد منظمتك).\n\n3. أدخل الكمية المستهدفة للفترة المحددة.\n\n4. اختر الوحدة (مثل كجم أو طن).\n\n5. احذف الصف بأيقونة الحذف عند عدم الحاجة إليه.\n\n6. انقر «حفظ» في رأس الصفحة عند الانتهاء.\n\nنصيحة: يلزم صف واحد مكتمل على الأقل (فئة، كمية، وحدة) قبل الحفظ.',
  },
  'supply-accepts-extra': {
    title: 'قبول تسليمات إضافية',
    content:
      '1. في صفحة التوريد، ابحث عن مفتاح «قبول تسليمات إضافية».\n\n2. عند التفعيل، يُسمح بالتسليمات التي تتجاوز الهدف وتظهر كتحذير في لوحة القياس.\n\n3. عند الإيقاف، قد تُعلَّم الكميات الزائدة على أنها غير مسموحة في لوحة القياس.\n\n4. انقر «حفظ» في رأس الصفحة بعد تغيير هذا الإعداد.\n\nأفضل ممارسة: فعّله فقط إذا كان منشأتك تستوعب تقلبات حجم الاستلام.',
  },
  dashboard: {
    title: 'لوحة قياس التنفيذ',
    content:
      'تقارن لوحة القياس المواد المستلمة بأهداف التوريد التي حددتها. تعرض بطاقات الملخص وأشرطة التقدم أداء الشهر والأسبوع في مكان واحد.\n\nاختر من الخيارات أدناه لمعرفة الخطوات خطوة بخطوة.',
  },
  'dashboard-overview': {
    title: 'نظرة عامة على لوحة القياس',
    content:
      '1. افتح «لوحة القياس» من الشريط الجانبي.\n\n2. تأكد من اختيار منظمة إعادة التدوير في القائمة المنسدلة.\n\n3. تعرض شارة في رأس الصفحة ما إذا كانت أهدافك أسبوعية أو شهرية.\n\n4. راجع بطاقات الملخص للهدف بالكجم والمستلم بالكجم ونسبة التنفيذ للفترة النشطة.\n\n5. بدّل بين «الشهر» و«الأسبوع» باستخدام التبويبات أسفل رأس الصفحة.\n\n6. استخدم «تحديث» في رأس الصفحة لإعادة تحميل البيانات، أو «تعديل التوريد» لتحديث الأهداف.',
  },
  'dashboard-fulfillment-status': {
    title: 'حالة التنفيذ',
    content:
      'يتضمن كل صف مادة شريط تقدم يعرض نسبة التنفيذ.\n\nعندما يتجاوز المستلم بالكجم الهدف، قد تظهر شارة حالة:\n\n• فوق الهدف — التسليم تجاوز الهدف؛ تظهر عند قبول الكميات الإضافية.\n• زيادة غير مسموحة — التسليم تجاوز الهدف لكن إعدادات التوريد لا تقبل كميات إضافية.\n\nتعكس ألوان شريط التقدم حالة التنفيذ. راجع مفتاح «قبول تسليمات إضافية» في التوريد إذا بدت الحالات غير متوقعة.',
  },
  'dashboard-empty-state': {
    title: 'لا توجد بيانات تنفيذ',
    content:
      '1. إذا لم تظهر صفوف في لوحة القياس، قد لا تكون الأهداف مُعدّة بعد.\n\n2. انقر «تعديل التوريد» في رأس الصفحة (أو افتح التوريد من الشريط الجانبي).\n\n3. أضف صفوف المواد وانقر «حفظ» في رأس الصفحة.\n\n4. عد إلى لوحة القياس وانقر «تحديث».\n\nنصيحة: تظهر بيانات التنفيذ بعد حفظ الأهداف وتسجيل تسليمات مطابقة لمنظمتك.',
  },
  orders: {
    title: 'الطلبات',
    content:
      'تتيح صفحة الطلبات مراجعة ملخص المقاييس والبحث والتصفية وإنشاء طلبات مسبقة لمنظمة إعادة التدوير. تظهر الطلبات في السوق للمطابقة مع التوريد.\n\nاختر من الخيارات أدناه لمعرفة الخطوات خطوة بخطوة.',
  },
  'orders-overview': {
    title: 'نظرة عامة على الطلبات',
    content:
      '1. افتح «الطلبات» من الشريط الجانبي.\n\n2. تأكد من اختيار منظمة إعادة التدوير في القائمة المنسدلة.\n\n3. راجع بطاقات الملخص لإجمالي الطلبات والمعلّقة والمنفّذة جزئياً والإجمالي.\n\n4. استخدم البحث وتصفية الحالة لتضييق القائمة.\n\n5. تصفّح جدول الطلبات للفئة والكمية والإنجاز والحالة.\n\n6. انقر «إنشاء طلب» في رأس الصفحة لفتح نافذة الإنشاء.\n\nنصيحة: تحتاج صلاحية إنشاء طلبات مسبقة لإضافة طلب جديد.',
  },
  'orders-summary': {
    title: 'بطاقات ملخص الطلبات',
    content:
      '1. أعلى صفحة الطلبات، أربع بطاقات تلخّص الطلبات المسبقة لمنظمتك.\n\n2. إجمالي الطلبات — عدد كل الطلبات المدرجة.\n\n3. معلّق — طلبات بانتظار التنفيذ.\n\n4. منفّذ جزئياً — طلبات ذات تقدّم جزئي في التسليم.\n\n5. إجمالي الكمية — مجموع كميات الطلبات (قد تختلف الوحدات حسب الطلب).\n\nنصيحة: تتحدّث البطاقات عند إنشاء أو حذف طلبات أو بعد إعادة تحميل البيانات.',
  },
  'orders-search-filter': {
    title: 'البحث وتصفية الطلبات',
    content:
      '1. في شريط التصفية أسفل بطاقات الملخص، استخدم «بحث في الطلبات» للمطابقة مع المعرّف أو فئة المادة أو المرجع أو الملاحظات.\n\n2. استخدم قائمة الحالة لعرض كل الحالات أو حالة محددة (مثل معلّق).\n\n3. يتحدّث الجدول فوراً لعرض الصفوف المطابقة.\n\nنصيحة: امسح نص البحث واضبط الحالة على «كل الحالات» لعرض القائمة كاملة مجدداً.',
  },
  'orders-create': {
    title: 'إنشاء طلب',
    content:
      '1. انقر «إنشاء طلب» في رأس صفحة الطلبات.\n\n2. اختر فئة المادة من القائمة (تُستمد من مواد منظمتك).\n\n3. أدخل كمية أكبر من صفر واختر الوحدة.\n\n4. أضف مرجعاً وملاحظات اختياريين.\n\n5. تبدأ الحالة كمعلّق ولا يمكن تغييرها في هذا النموذج.\n\n6. انقر «إنشاء طلب» في النافذة للإرسال، أو «إلغاء» للإغلاق دون حفظ.\n\nنصيحة: إذا كان الإنشاء معطّلاً، قد لا يملك دورك صلاحية إنشاء طلبات مسبقة.',
  },
  'orders-table': {
    title: 'جدول الطلبات',
    content:
      '1. يعرض الجدول معرّف الطلب وفئة المادة والكمية ونسبة الإنجاز والحالة والمرجع وتاريخ الإنشاء والإجراءات.\n\n2. تُظهر شارات الحالة: معلّق، منفّذ جزئياً، مكتمل، وما شابه.\n\n3. للطلبات المعلّقة، استخدم إجراء الحذف عندما يسمح دورك بذلك.\n\n4. إذا لم تظهر صفوف، عدّل البحث أو تصفية الحالة.\n\nنصيحة: تعكس نسبة الإنجاز التقدّم مقابل الكمية المطلوبة عند توفرها.',
  },
  notifications: {
    title: 'الإشعارات',
    content:
      'تُبقيك الإشعارات على اطلاع بنشاط المنصة. افتح «الإشعارات» من تذييل الشريط الجانبي لمراجعة العناصر غير المقروءة في صفحة مخصصة.\n\nاختر من الخيارات أدناه لمعرفة الخطوات خطوة بخطوة.',
  },
  'notification-page': {
    title: 'فتح الإشعارات',
    content:
      '1. انقر «الإشعارات» في تذييل الشريط الجانبي (فوق «المساعدة»).\n\n2. تعرض الشارة على الأيقونة عدد الإشعارات غير المقروءة.\n\n3. تفتح صفحة الإشعارات مع تبويبي «غير مقروء» و«مقروء» أسفل رأس الصفحة.\n\n4. مرّر في القائمة لمراجعة التنبيهات الأخيرة لمنظمتك.\n\nتُقيَد الإشعارات بالمنظمة المحددة في الشريط الجانبي.',
  },
  'mark-notifications-read': {
    title: 'تعليم الإشعارات كمقروءة',
    content:
      '1. افتح «الإشعارات» من الشريط الجانبي.\n\n2. في تبويب «غير مقروء»، انقر على إشعار لتعليمه كمقروء — ينتقل إلى تبويب «مقروء».\n\n3. استخدم «تعليم الكل كمقروء» في رأس الصفحة لمسح جميع الإشعارات غير المقروءة دفعة واحدة.\n\n4. يتحدّث عداد الشارة في الشريط الجانبي فوراً بعد التعليم.',
  },
  'account-settings': {
    title: 'الحساب والتفضيلات',
    content:
      'افتح قائمة الحساب من ملفك الشخصي في أسفل الشريط الجانبي لتغيير لغة الواجهة والتبديل بين الوضع الفاتح والداكن وتسجيل الخروج. يعرض ملفك اسم المستخدم والمنظمة النشطة.\n\nاختر من الخيارات أدناه لمعرفة الخطوات خطوة بخطوة.',
  },
  'change-language': {
    title: 'تغيير اللغة',
    content:
      '1. انقر ملفك الشخصي في أسفل الشريط الجانبي لفتح قائمة الحساب.\n\n2. انقر «اللغات».\n\n3. اختر لغتك من القائمة: الإنجليزية، العربية، الأردية، الهندية، البنغالية، السنهالية، أو النيبالية.\n\n4. تتحدّث الواجهة فوراً، ويُحفظ اختيارك عند تسجيل الدخول التالي.\n\nملاحظة: العربية والأردية تُحوّلان التخطيط تلقائياً إلى اليمين لليسار (RTL). مقالات المساعدة متوفرة بجميع اللغات المدعومة.',
  },
  'appearance-theme': {
    title: 'الوضع الفاتح والداكن',
    content:
      '1. انقر ملفك الشخصي في أسفل الشريط الجانبي لفتح قائمة الحساب.\n\n2. استخدم مفتاح «الوضع الداكن» للتبديل بين السمات الفاتحة والداكنة.\n\n3. يُحفظ تفضيلك تلقائياً ويُطبَّق في كل زيارة.',
  },
};
